import React, { useState, useEffect } from 'react';
import { FaBook, FaArrowRight, FaQuoteLeft } from 'react-icons/fa';
import '../../../assets/css/student/blogs/Hero.css';

const BlogHeroSection = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const scrollToBlogs = () => {
    const section = document.getElementById('latest-blogs');
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToStories = () => {
    const section = document.getElementById('success-stories');
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="blog-hero-section">
      {/* Background Image */}
      <div className="blog-hero-background"></div>
    
      {/* Overlay */}
      <div className="blog-hero-overlay"></div>

      {/* Animated Particles */}
      <div className="blog-particles">
        <div className="particle particle-1"></div>
        <div className="particle particle-2"></div>
        <div className="particle particle-3"></div>
        <div className="particle particle-4"></div>
        <div className="particle particle-5"></div>
        <div className="particle particle-6"></div>
      </div>

      {/* Content Container */}
      <div className={`blog-hero-content ${isVisible ? 'fade-in-up' : ''}`}>
        {/* Decorative Icon */}
        <div className="blog-hero-icon">
          <FaBook />
        </div>

        {/* Main Heading */}
        <div className="blog-hero-header">
          <p className="blog-hero-subtitle">OUR BLOG / INSIGHTS / STORIES</p>
          <h1 className="blog-hero-title">
            <FaQuoteLeft className="quote-icon" />
            Empowering Education<br />
            Through <span className="highlight-word">Transparency</span>
          </h1>
        </div>

        {/* Description */}
        <p className="blog-hero-description">
          Discover inspiring stories of students whose lives have been transformed 
          through education. Read about our journey, impact, and the difference 
          your support makes in creating a brighter future for underprivileged students.
        </p>

        {/* CTA Buttons */}
        <div className="blog-hero-buttons">
          <button onClick={scrollToBlogs} className="blog-btn blog-btn-primary">
            <span>Read Blogs</span>
            <FaArrowRight className="btn-arrow" />
          </button>
          
          <button onClick={scrollToStories} className="blog-btn blog-btn-secondary">
            <span>Explore Stories</span>
            <FaArrowRight className="btn-arrow" />
          </button>
        </div>

        {/* Decorative Stats */}
        <div className="blog-hero-stats">
          <div className="stat-box">
            <h3>500+</h3>
            <p>Success Stories</p>
          </div>
          <div className="stat-divider"></div>
          <div className="stat-box">
            <h3>1000+</h3>
            <p>Inspiring Articles</p>
          </div>
          <div className="stat-divider"></div>
          <div className="stat-box">
            <h3>50K+</h3>
            <p>Readers Monthly</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BlogHeroSection;